// Investiture
import React from 'react';
import Investiture2024  from 'views/Investiture2024';

const InvestiturePage = () => {
  return <Investiture2024 />;
};

export default InvestiturePage;
